import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const FermExplainer = ({ dark = true }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label="What is a F.E.R.M?"
        data-testid="ferm-help-button"
        className={`inline-flex items-center justify-center w-11 h-11 rounded-full border-2 transition-[background-color,border-color,transform] hover:-translate-y-0.5 ${
          dark ? "border-[#8FA58A]/60 text-[#8FA58A] hover:bg-[#8FA58A] hover:text-[#121E2B]" : "border-[#1B2A41]/30 text-[#1B2A41] hover:bg-[#1B2A41] hover:text-[#FDFBF7]"
        }`}
      >
        <HelpCircle className="w-5 h-5" />
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" sideOffset={10} data-testid="ferm-help-popover" className="w-[min(92vw,420px)] bg-[#FAF8F2] border-[#E2705A]/40 text-[#1E2830] p-5 shadow-2xl">
      <p className="font-type text-[11px] uppercase tracking-[0.3em] text-[#5A7355]">What's a F.E.R.M?</p>
      <p className="font-type font-bold text-xl text-[#E2705A] mt-1 leading-tight">Federal Electoral Representative Member</p>
      <p className="text-sm mt-3 leading-relaxed">
        Ten everyday Aussies in every one of the 150 federal electorates — a collective working body that holds the sitting member
        accountable and, nationally, lets us collaborate against poor policy before it lands.
      </p>
      <ul className="mt-3 space-y-1.5 text-sm">
        <li className="flex gap-2"><span className="text-[#E2705A] font-type">1.</span> Know your member's record and put the R.O.A.N pillars in front of them, on the record.</li>
        <li className="flex gap-2"><span className="text-[#E2705A] font-type">2.</span> Read the bills together — what they actually do, section by section — and say so.</li>
      </ul>
      <div className="mt-4 rounded-xl bg-[#E5EDE3] border border-[#8FA58A]/40 p-3 text-xs leading-relaxed">
        <p className="font-semibold text-[#1B2A41]">Why it matters for Pillars 3 &amp; 4</p>
        <p className="mt-1">
          Watching how politicians actually decide shows exactly why we need <strong>Pillar 3 — People’s Initiative</strong> and{" "}
          <strong>Pillar 4 — People’s Veto on Bills</strong>: the people's own tools to put questions to the nation and to strike out
          laws that should never have passed.
        </p>
      </div>
    </PopoverContent>
  </Popover>
);
